import React from "react"

import styles from "./SmsSendingRulesMappingTable.module.scss"

// TODO: この書き方どうにかしたい(?)
type Salon = { id: number; displayName: string }
type Rule = { id: string; name?: string | null }

export type SmsSendingRulesMappingTableProps = {
	salons: Salon[]
	rules: Rule[]
	value: Record<number, string | null>
	onChange: (salonId: number, ruleId: string, checked: boolean) => void
	errorSalonIds?: number[]
}

export const SmsSendingRulesMappingTable: React.FC<
	SmsSendingRulesMappingTableProps
> = ({ salons, rules, value, onChange, errorSalonIds = [] }) => {
	return (
		<div className={styles.table_wrapper}>
			<table className={styles.table}>
				<thead>
					<tr>
						<th className={`${styles.th} ${styles.header_cell}`}>店舗名</th>
						{rules.map((r) => (
							<th key={r.id} className={`${styles.th} ${styles.header_cell}`}>
								{r.name ?? "(名称未設定)"}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{salons.map((s) => {
						const hasError = errorSalonIds.includes(s.id)
						return (
							<tr
								key={s.id}
								className={hasError ? styles.row_error : undefined}
							>
								<td className={styles.td}>{s.displayName}</td>
								{rules.map((r) => {
									const checked = value[s.id] === r.id
									return (
										<td key={r.id} className={styles.td}>
											<input
												type="checkbox"
												checked={checked}
												onChange={(e) => onChange(s.id, r.id, e.target.checked)}
											/>
										</td>
									)
								})}
							</tr>
						)
					})}
				</tbody>
			</table>
		</div>
	)
}

export default SmsSendingRulesMappingTable
